export default __webpack_public_path__ + "static/media/03.f53cf0fe.jpg";